<template>
	<div class="home">
		<navComponent/>
		<LandingComponent />
	</div>
</template>

<script>
  import navComponent from '@/components/nav.vue'
  import LandingComponent from '@/components/Landing.vue'
  export default {
    name: 'home',
    data() {
      return {}
    },
    components: {
      navComponent,
      LandingComponent
    },
    methods: {

    },
    created() {
      if (localStorage.getItem('user_verify')){
        this.$router.push('/verify')
      }
    }
  }
</script>

